import { IProjectCreateRequest, IProjectDetail, IProjectIncentiveMatch, IProjectListItem, IProjectResponse, IProjectUpdateRequest } from "../contracts/Project";
import { deleteDataAsync, getDataAsync, postDataAsync, putDataAsync } from "../ZeosApiExecutor";
import { IProjects } from "./interfaces/IProjects";

const projectsPrefix = "/projects/";

export const Projects: IProjects = {
  createProject: async (request: IProjectCreateRequest) => {
    const response = await postDataAsync<IProjectResponse>(
      `${projectsPrefix}`,
      request
    );
    return response;
  },
  updateProject: async (projectId: number, request: IProjectUpdateRequest) => {
    const response = await putDataAsync<IProjectResponse>(
      `${projectsPrefix}${projectId}`,
      request
    );
    return response;
  },
  getProjectsByProperty: async (propertyId: number) => {
    const response = await getDataAsync<IProjectListItem[]>(
      `${projectsPrefix}?propertyId=${propertyId}`,
      ""
    );
    return response;
  },
  getProjectById: async (projectId: number, forceAiSummary?: boolean) => {
    const forceParam = forceAiSummary ? "?forceAiSummary=true" : "";
    const response = await getDataAsync<IProjectDetail>(
      `${projectsPrefix}${projectId}${forceParam}`,
      ""
    );
    return response;
  },
  getProjectIncentiveMatches: async (projectId: number) => {
    const response = await getDataAsync<IProjectIncentiveMatch[]>(
      `${projectsPrefix}${projectId}/incentives`,
      ""
    );
    return response;
  },
  deleteProject: async (projectId: number) => {
    const response = await deleteDataAsync<boolean>(
      `${projectsPrefix}${projectId}`,
      null
    );
    return response;
  },
};
